import api from '../../services/api';

const state = {
  logs: [],
  total: 0,
  page: 1,
  pageSize: 50,
  loading: false,
};

const getters = {
  allLogs: s => s.logs,
  total: s => s.total,
  isLoading: s => s.loading,
};

const actions = {
  async fetchLogs({ commit }, filters = {}) {
    commit('SET_LOADING', true);
    try {
      const qs = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') qs.append(k, v);
      });
      const res = await api.get(`/audit?${qs.toString()}`);
      commit('SET_LOGS', res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch logs' };
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const mutations = {
  SET_LOGS(s, payload) {
    s.logs = payload.logs || [];
    s.total = payload.total || 0;
    s.page = payload.page || 1;
    s.pageSize = payload.page_size || 50;
  },
  SET_LOADING(s, v) { s.loading = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
